import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze kategorií — zrcadlo Tabidoo tabulky „kategorieproduktu". */
export function DatabazeKategoriiPage() {
  return (
    <TabidooTablePage
      table="kategorie"
      storagePrefix="kategorie"
      title="Databáze kategorií"
      subtitle="Zrcadlo z Tabidoo. Hledej globálně, filtruj po sloupcích, přehazuj sloupce tažením. Klikni na řádek pro detail a editaci."
    />
  );
}
